import Chart from "react-apexcharts";
import React, { useState, useEffect } from "react";

const BarChartEvent = ({ filteredData, name }) => {
  const [eSeries, setESeries] = useState([]);
  const [options, setOptions] = useState({});

  const calculateTickInterval = (maxValue) => {
    if (maxValue <= 10) return 1; 
    if (maxValue <= 50) return 5; 
    if (maxValue <= 100) return 10; 
    return Math.ceil(maxValue / 10); 
  };

  useEffect(() => {
    if (filteredData && filteredData.length > 0) {
      const xCategories = filteredData.map((item) => item.x); // x-axis labels
      const yData = filteredData.map((item) => item.y); // y-axis data

      const maxValue = Math.max(...yData);
      const interval = calculateTickInterval(maxValue);

      // Configure the chart options dynamically
      setOptions({
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "30%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          labels: {
            rotate: -45,
            rotateAlways: true,
            trim: true,
          },
          categories: xCategories,
        },
        yaxis: {
          title: {
            text: name || "Event Count",
            style: {
              fontSize: "13px",
              fontWeight: "700",
              color: "#333",
              fontFamily: "Mars Centra",
            },
          },
          labels: {
            formatter: (val) => (val % interval === 0 ? val : ""), // Show values only at regular intervals
          },
          tickAmount: Math.ceil(maxValue / interval), // Set tick count based on interval
          max: Math.ceil(maxValue / interval) * interval, // Ensure the max aligns with the interval
          min: 0,
        },
        fill: {
          colors: ["#00008B"],
          opacity: 1,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (value) => `${value} ${name || "Events"}`,
          },
        },
      });

      // Set the chart series data
      setESeries([
        {
          name: "Event Count",
          data: yData,
        },
      ]);
    } else {
      // Handle case when no data is available
      setOptions({
        chart: {
          type: "bar",
          height: 350,
        },
        xaxis: {
          categories: ["No Data"],
        },
        yaxis: {
          title: {
            text: name || "Event Count",
          },
        },
      });

      setESeries([
        {
          name: "Event Count",
          data: [0],
        },
      ]);
    }
  }, [filteredData, name]);

  return <Chart options={options} series={eSeries} type="bar" />;
};

export default BarChartEvent;
